import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dropdown, DropdownButton } from 'react-bootstrap';
import classNames from 'classnames';

import BtnTripTypes from 'modules/kiosk/components/BtnTripTypes';
import ErrorMsg from 'modules/shared/ErrorMsg';

import { depTitleSelector, securityGateSelector } from 'modules/common/Header/selectors';
import { branchTitleSelector } from 'modules/common/LogoutBtn/selectors';
import { getPheripRequest, getSecGateRequest, setDepTitle as setReduxDepTitle } from 'modules/common/Header/actions';
import { Checkbox } from 'modules/shared/Forms';
import styles from './Landing.module.scss';

const Landing: React.FC = () => {
  const dispatch = useDispatch();
  const securityGate = useSelector(securityGateSelector);
  const branch = useSelector(branchTitleSelector);
  const depTitle = useSelector(depTitleSelector) || { id: securityGate[0]?.id, name: securityGate[0]?.name };
  const [depError, setDepError] = useState<string | null>(null);
  // I was forced to add any type to use the state for the value property in CheckBox component
  const [isPersonalDataHandlingAccepted, setIsPersonalDataHandlingAccepted] = useState<boolean | any>(false);

  const handleChangeSelect = (eventKey: any, a: any) => {
    const id = a.target?.id || '';

    setDepError(null);
    localStorage.setItem('depTitle', JSON.stringify({ name: eventKey, id }));
    dispatch(setReduxDepTitle({ name: eventKey, id }));
    dispatch(getPheripRequest(id));
  };

  const handleAcceptClick = () => {
    setIsPersonalDataHandlingAccepted((state: boolean) => !state);
    if (depTitle) {
      dispatch(getPheripRequest(`${depTitle.id}`));
    }
  };

  useEffect(() => {
    const bid = branch?.id || JSON.parse(localStorage.getItem('branchId') || '')?.id;
    if (!securityGate.length && bid) {
      dispatch(getSecGateRequest({ branchId: branch?.id }));
    }
  }, [branch]);

  return (
    <div className={classNames(styles.landing, 'kiosk-main')}>
      <ErrorMsg isShow={!!depError} error={depError || ''} closeHandler={() => setDepError(null)} />
      <DropdownButton
        menuAlign="left"
        variant="outline-secondary"
        className={classNames(styles.select, depTitle ? styles.bck_red : styles.bck_yellow)}
        title={depTitle?.name || 'Оберіть КПП'}
        onSelect={(e: any, a: any) => handleChangeSelect(e, a)}
      >
        {securityGate.map((dep: any) => (
          <Dropdown.Item key={dep.id} className={styles.item} eventKey={dep.name} id={dep.id}>
            {dep.name}
          </Dropdown.Item>
        ))}
      </DropdownButton>

      {depTitle && (
        <>
          <div className={styles.button_wraper}>
            <div className={styles.acceptPersonalData}>
              <div style={{ backgroundColor: 'white', padding: 10, borderRadius: 10, opacity: 80 }}>
                <Checkbox
                  label="Згоден на обробку персональних даних"
                  value={isPersonalDataHandlingAccepted}
                  name="personalDataAccept"
                  onChange={handleAcceptClick}
                  className={styles.personalDataCheckBox}
                  isKiosk
                />
              </div>
            </div>

            <BtnTripTypes areActive={isPersonalDataHandlingAccepted} />
          </div>
        </>
      )}

      <h3 className={styles.version}>Version:{process.env.REACT_APP_VERSION}</h3>
    </div>
  );
};

export default Landing;
